<template>
    <div
        @click="changeCurrentFile"
        :style="{
            'background-color': active ? player.mainColor : 'transparent',
            color: active ? computedTextColor : player.headingColor,
        }"
        class="cursor-pointer relative group"
        :class="{ 'opacity-50': isNotReleased }"
    >
        <div
            class="absolute inset w-full h-full opacity-0 group-hover:opacity-10 transition-all"
            :style="{
                'background-color': player.mainColor,
            }"
        ></div>
        <div class="h-full w-full flex p-3 items-center space-x-2">
            <div class="flex-shrink-0">
                <div
                    class="ct-bg-success--solid rounded-full flex flex-shrink-0 items-center justify-center h-5 w-5"
                    v-if="isWatched"
                >
                    <CheckIcon class="text-white h-4 w-4" />
                </div>
                <component
                    v-if="!isWatched && fileIcon"
                    :is="fileIcon"
                    class="h-5 w-5 opacity-80"
                />
            </div>
            <div class="flex-grow">
                <cUtilsEdit @edit="goToFileField(file.id, 'fileName')">
                    <p class="text-sm font-medium opacity-90">
                        {{ file.name }}
                    </p>
                </cUtilsEdit>
            </div>
            <div class="flex-shrink-0" v-if="file.info">
                <cUtilsEdit @edit="goToFileField(file.id, 'fileInfo')">
                    <p class="text-sm opacity-80">{{ file.info }}</p>
                </cUtilsEdit>
            </div>
        </div>
    </div>
</template>

<script>
import {
    VideoIcon,
    AudioIcon,
    PdfIcon,
    DownloadFileIcon,
    EmbedIcon,
    ImageIcon,
    TextFileIcon,
    CheckIcon,
} from "@easy/ui/icons";
import { PLAYER_FILE_TYPES } from "@/apps/player/services/players.service";
import { markRaw } from "vue";
import { usePlayerGoTo } from "@/views/tools/player/utils/usePlayerGoTo";
import { mapState, mapMutations, mapGetters } from "vuex";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { isColorDark } from "@/shared/utils/helpers";

export default {
    name: "SidebarFile",
    props: {
        file: Object,
    },
    setup() {
        const { goToFileField } = usePlayerGoTo();
        return { goToFileField };
    },
    components: {
        CheckIcon,
        cUtilsEdit,
    },
    computed: {
        ...mapState("player/view", ["player", "watched"]),
        ...mapGetters("player/view", ["currentFile"]),
        computedTextColor() {
            return isColorDark(this.player.mainColor) ? "#ffffff" : "#000000";
        },
        active() {
            return this.currentFile.id === this.file.id;
        },
        isWatched() {
            return this.watched.indexOf(this.file.id) !== -1;
        },
        isNotReleased() {
            return this.file.releaseAt && new Date(this.file.releaseAt) > new Date();
        },
        fileIcon() {
            let icon;
            switch (this.file.type) {
                case PLAYER_FILE_TYPES.audio:
                    icon = markRaw(AudioIcon);
                    break;
                case PLAYER_FILE_TYPES.video:
                    icon = markRaw(VideoIcon);
                    break;
                case PLAYER_FILE_TYPES.pdf:
                    icon = markRaw(PdfIcon);
                    break;
                case PLAYER_FILE_TYPES.file:
                    icon = markRaw(DownloadFileIcon);
                    break;
                case PLAYER_FILE_TYPES.embed:
                    icon = markRaw(EmbedIcon);
                    break;
                case PLAYER_FILE_TYPES.image:
                    icon = markRaw(ImageIcon);
                    break;
                case PLAYER_FILE_TYPES.text:
                    icon = markRaw(TextFileIcon);
                    break;
                case PLAYER_FILE_TYPES.google:
                    icon = markRaw(TextFileIcon);
                    break;
                default:
                    icon = null;
            }
            return icon;
        },
    },
    methods: {
        ...mapMutations("player/view", ["setCurrentFile", "setMenuOpen"]),
        changeCurrentFile() {
            this.setCurrentFile({ file: this.file });
            this.setMenuOpen(false);
        },
    },
};
</script>
